import makeStyles from "@mui/styles/makeStyles";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import ListItemText from "@mui/material/ListItemText";
import Popover from "@mui/material/Popover";
import MenuItem from "@mui/material/MenuItem";
import Close from "@mui/icons-material/Close";
import { useContext, useState } from "react";
import { GlobalContext } from "../App";
import { FilterIcon } from "./FilterIcon";

const useStyles = makeStyles(() => ({
  paper: {
    maxHeight: "35vh",
    "& .MuiPopover-paper": {
      borderRadius: "15px",
      paddingTop: "6px",
      paddingBottom: "6px",
      minWidth: "300px",
    },
    "& .MuiTypography-body1": {
      fontSize: "13px",
      color: "#294A59",
      fontWeight: 700,
    },
    marginTop: "15px",
  },
  menuItem: {
    textTransform: "uppercase",
    paddingTop: "0px",
    paddingBottom: "0px",
    minHeight: "0px",
  },
  iconButton: {
    flex: "1",
  },
  filterButton: {
    "&:hover": {
      background: "transparent",
    },
    fontFamily: '"tablet-gothic-wide", "Helvetica", "Arial", sans-serif',
    fontWeight: 700,
    color: "#294a59",
  },
}));

export const MapFilter = () => {
  const {
    skinProblems,
    selectedFilterSkinConditions,
    setSelectedFilterSkinConditions,
  } = useContext(GlobalContext);

  const [anchorEl, setAnchorEl] = useState(null);
  const [isOpen, setIsOpen] = useState(false);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
    setIsOpen(!isOpen);
  };

  const handleClose = () => {
    setAnchorEl(null);
    setIsOpen(!isOpen);
  };

  const id = isOpen ? "simple-popover" : undefined;

  const classes = useStyles();

  return (
    <>
      <IconButton className={classes.iconButton} onClick={handleClick}>
        <FilterIcon />
      </IconButton>
      <Popover
        id={id}
        open={isOpen}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        className={classes.paper}
      >
        {selectedFilterSkinConditions?.length > 0 && (
          <MenuItem
            onClick={() => setSelectedFilterSkinConditions([])}
            className={classes.menuItem}
          >
            <Button
              disableRipple
              className={classes.filterButton}
              startIcon={<Close />}
            >
              Remove All Selected
            </Button>
          </MenuItem>
        )}
        {skinProblems.map((skinProblem) => (
          <MenuItem
            key={skinProblem}
            className={classes.menuItem}
            onClick={() => {
              if (selectedFilterSkinConditions?.includes(skinProblem)) {
                setSelectedFilterSkinConditions((prev) =>
                  [...prev].filter((n) => n !== skinProblem)
                );
              } else {
                setSelectedFilterSkinConditions((prev) => [
                  ...prev,
                  skinProblem,
                ]);
              }
              //   setIsOpen(false);
            }}
            selected={selectedFilterSkinConditions?.includes(skinProblem)}
          >
            <ListItemText dense="true" primary={skinProblem} />
          </MenuItem>
        ))}
      </Popover>
    </>
  );
};
